<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;" fluid>

    <v-row class="grey lighten-4 pa-6">

      <v-row>
        <v-col lg="2" md="4" sm="6" xs="12" cols="12">
          <v-card :loading="loading" class="statCard">
            <v-card-text class="py-0">
              <v-row>
                <v-col cols="12" class="pt-0">
                  <v-row class="align-center">
                    <v-col cols="12" FIELD>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div class="d-flex py-1">
                            <v-icon size="20" class="black--text px-2">account_balance</v-icon>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`" v-bind="attrs" v-on="on">
                              {{i18n['total']}}
                            </div>
                          </div>
                        </template>
                        <div :class="`${arabic ? 'arFont' : 'enFont'} white--text`">
                          {{ i18n['amounts_available_to_withdraw_except_what_is_withdrawn_already'] }}
                        </div>
                      </v-tooltip>
                      <v-row>
                        <v-col class="my-0 py-0">
                          <v-card color="grey lighten-2" class="text-center py-3 mt-3" flat>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">
                              {{ i18n['usd'] }}
                            </div>
                            <div class="mt-1 statValue">
                              {{ counters.total_ready }}
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col lg="2" md="4" sm="6" xs="12" cols="12">
          <v-card thirdPanel :loading="loading" class="statCard">
            <v-card-text class="py-0">
              <v-row>
                <v-col cols="12" class="pt-0">
                  <v-row class="align-center">
                    <v-col cols="12" FIELD>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div class="d-flex py-1">
                            <v-icon size="20" class="black--text px-2">price_change</v-icon>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`" v-bind="attrs" v-on="on">
                              {{ i18n['total_expected_profit'] }}
                            </div>
                          </div>
                        </template>
                        <div :class="`${arabic ? 'arFont' : 'enFont'} white--text`">
                          {{ i18n['pending_profits_available_to_withdraw'] }}
                        </div>
                      </v-tooltip>
                      <v-row>
                        <v-col class="my-0 py-0">
                          <v-card color="grey lighten-2" class="text-center py-3 mt-3" flat>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">
                              {{i18n['usd']}}
                            </div>
                            <div class="mt-1 statValue">
                              {{ counters.total_pending }}
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col lg="2" md="4" sm="6" xs="12" cols="12">
          <v-row>
            <v-col cols="12" class="py-0">
              <v-card :loading="loading" class="statCard">
                <v-card-text class="py-0">
                  <v-row>
                    <v-col cols="12">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div class="d-flex py-1">
                            <v-icon size="20" class="black--text px-2">account_balance</v-icon>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`" v-bind="attrs" v-on="on">
                              {{ i18n['total_profit_from_orders'] }}
                            </div>
                          </div>
                        </template>
                        <div :class="`${arabic ? 'arFont' : 'enFont'} white--text`">
                          {{ i18n['amounts_available_to_withdraw'] }}
                        </div>
                      </v-tooltip>
                      <v-row class="align-center">
                        <v-col cols="6" class="mx-0 px-0" FIELD>
                          <v-card color="grey lighten-2" class="text-center py-3" flat>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">
                              {{i18n['orders']}}
                            </div>
                            <div class="mt-1 statValue">
                              {{ counters.count }}
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="6" class="mx-0 px-1" FIELD>
                          <v-card color="grey lighten-2" class="text-center py-3" flat>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">
                              {{ i18n['usd'] }}
                            </div>
                            <div class="mt-1 statValue">
                              {{ counters.sum }}
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col lg="2" md="4" sm="6" xs="12" cols="12">
          <v-row>
            <v-col cols="12" class="py-0" PANNELS>

              <v-card thirdPanel :loading="loading" class="statCard">
                <v-card-text class="py-0">
                  <v-row>
                    <v-col cols="12">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div class="d-flex py-1">
                            <v-icon size="20" class="black--text px-2">price_change</v-icon>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`" v-bind="attrs" v-on="on">
                              {{ i18n['expected_profit_from_orders'] }}
                            </div>
                          </div>
                        </template>
                        <div :class="`${arabic ? 'arFont' : 'enFont'} white--text`">
                          {{ i18n['orders_delivered_since_less_than_7_days'] }}
                        </div>
                      </v-tooltip>
                      <v-row class="align-center">
                        <v-col cols="6" class="mx-0 px-0" FIELD>
                          <v-card color="grey lighten-2" class="text-center py-3" flat>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">
                              {{i18n['orders']}}
                            </div>
                            <div class="mt-1 statValue">
                              {{ counters.pending_count }}
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="6" class="mx-0 px-1" FIELD>
                          <v-card color="grey lighten-2" class="text-center py-3" flat>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">
                              {{i18n['usd']}}
                            </div>
                            <div class="mt-1 statValue">
                              {{ counters.pending_sum }}
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col lg="2" md="4" sm="6" xs="12" cols="12" v-if="user.affiliate">
          <v-row>
            <v-col cols="12" class="py-0">

              <v-card :loading="loading" color="primary" class="statCard">
                <v-card-text class="py-0">
                  <v-row>
                    <v-col cols="12">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div class="d-flex py-1">
                            <v-icon size="20" class="white--text px-2">account_balance</v-icon>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} white--text`" v-bind="attrs" v-on="on">
                              {{i18n['total_profits_from_affiliation']}}
                            </div>
                          </div>
                        </template>
                        <div :class="`${arabic ? 'arFont' : 'enFont'} white--text`">
                          {{ i18n['amounts_available_to_withdraw'] }}
                        </div>
                      </v-tooltip>
                      <v-row class="align-center">
                        <v-col cols="6" class="mx-0 px-0">
                          <v-card color="grey lighten-2" class="text-center py-3" flat>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">
                              {{ i18n['orders']}}
                            </div>
                            <div class="mt-1 statValue">
                              {{ counters.ready_affiliate_count }}
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="6" class="mx-0 px-1">
                          <v-card color="grey lighten-2" class="text-center py-3" flat>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">
                              {{i18n['usd']}}
                            </div>
                            <div class="mt-1 statValue">
                              {{ counters.ready_affiliate_amount }}
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col lg="2" md="4" sm="6" xs="12" cols="12" v-if="user.affiliate">
          <v-row>
            <v-col cols="12" class="py-0" PANNELS>
              <v-card thirdPanel :loading="loading" color="primary" class="statCard">
                <v-card-text class="py-0">
                  <v-row>
                    <v-col cols="12">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div class="d-flex py-1">
                            <v-icon size="20" class="white--text px-2">price_change</v-icon>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} white--text`" v-bind="attrs" v-on="on">
                              {{ i18n['expected_profit_from_affiliation'] }}
                            </div>
                          </div>
                        </template>
                        <div :class="`${arabic ? 'arFont' : 'enFont'} white--text`">
                          {{ i18n['orders_delivered_since_less_than_7_days'] }}
                        </div>
                      </v-tooltip>
                      <v-row class="align-center">
                        <v-col cols="6" class="mx-0 px-0">
                          <v-card color="grey lighten-2" class="text-center py-3" flat>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">
                              {{i18n['orders']}}
                            </div>
                            <div class="mt-1 statValue">
                              {{ counters.pending_affiliate_count }}
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="6" class="mx-0 px-1">
                          <v-card color="red lighten-2" class="text-center py-3" flat>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">
                              {{i18n['usd']}}
                            </div>
                            <div class="mt-1 statValue">
                              {{ counters.pending_affiliate_amount }}
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row v-if="counters.subvendor">
        <v-col md="xs" cols="12">
          <SubVendorInvoices :invoicesData="counters.subvendor_invoicing" />
        </v-col>
      </v-row>

      <v-col cols="12" class="pa-0">
        <v-row>
          <v-col cols="12" md="6" class="pt-0" REQUESTS>
            <v-row>
              <v-col cols="12" PANNELS>
                <v-card TRANSACTIONS :loading="loading">
                  <v-card-text class="py-0">
                    <v-row>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" md="2" class="text-center" TITLEICON>
                            <v-icon size="40" color="secondary">price_check</v-icon>
                          </v-col>
                          <v-col cols="10" md="10" TITLE>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">
                              {{ i18n['withdrawal_requests'] }}
                            </div>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">
                              {{ i18n['your_withdrawal_requests'] }}
                            </div>
                          </v-col>
                          <v-col cols="12" md="12" class="text-center" TITLE>
                            <div v-if="disable_universal.error_message"
                              :class="`${arabic ? 'arFont' : 'enFont'} text-center`">
                              {{ disable_universal.error_message }}
                            </div>
                            <v-btn v-if="disable_universal.id_verification" color="secondary" @click="goTo('/account')"
                              :class="`${arabic ? 'arFont' : 'enFont'}`">
                              {{ i18n['click_here_to_verify_your_account'] }}
                            </v-btn>
                            <v-btn v-if="disable_universal.payment_methods" color="secondary" @click="goTo('/account')"
                              :class="`${arabic ? 'arFont' : 'enFont'}`">
                              {{ i18n['click_here_to_add_payment_method'] }}
                            </v-btn>

                          </v-col>
                          <v-col cols="12" md="12" class="py-0" TITLE>
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn block :class="`${arabic ? 'arFont' : 'enFont'}`" :loading="loading"
                                  color="primary" v-on="on" :disabled="disable_universal.disable"
                                  @click="dialog = true">
                                  <v-icon left>
                                    local_atm
                                  </v-icon>
                                  {{ i18n['withdrawal_request'] }}
                                </v-btn>
                              </template>
                              <span :class="`${arabic ? 'arFont' : 'enFont'}`">
                                {{ i18n['fees_deducted_from_your_profits_as_per_payment_method'] }}
                              </span>
                            </v-tooltip>

                          </v-col>
                          <v-col cols="12" md="12" class="py-0" TITLE>
                            <v-layout row justify-center>
                              <v-dialog v-model="dialog" persistent max-width="600">
                                <v-card>
                                  <v-card-title :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:20px">
                                    {{ i18n['withdraw_request'] }}
                                  </v-card-title>
                                  <v-card-text>
                                    <v-row class="align-center">
                                      <v-col cols="12" FIELD :class="
                                        `${arabic ? 'arFont' : 'enFont'}`
                                      ">
                                        {{ i18n['profit_available_to_withdraw'] }}:
                                        <v-chip label color="primary" style="direction:ltr;">${{ counters.total_ready
                                        }}</v-chip>
                                      </v-col>
                                      <v-col cols="12" FIELD>
                                        <v-autocomplete :items="accountPaymentMethods"
                                          v-model="newRequest.payment_method_id" 
                                          :label="i18n['profit_withdrawal_method']"
                                          autocomplete="disabled" outlined hide-details clearable dense item-value="id"
                                          :class="
                                            `${arabic ? 'arFont' : 'enFont'}`
                                          ">
                                          <template v-slot:selection="{
                                              attr,
                                              on,
                                              item,
                                              selected,
                                            }">
                                            <span v-bind="attr" :input-value="selected" v-on="on" :class="
  `${arabic ? 'arFont' : 'enFont'
  }`
">
                                              <v-chip x-small>{{
    item.name
}}</v-chip>
                                            </span>
                                          </template>
                                          <template v-slot:item="{ item }">
                                            <span :class="
  `${arabic ? 'arFont' : 'enFont'
  }`
" v-if="
  paymentMethods.filter(
    (x) => x.slug == item.type
  ).length
">
                                              {{ item.name }}
                                              <v-chip x-small color="secondary">{{
    paymentMethods.filter(
      (x) => x.slug == item.type
    )[0][language]
}}</v-chip>
                                            </span>
                                          </template>
                                        </v-autocomplete>
                                      </v-col>
                                      <v-col cols="12" md="12" :class="
  `${arabic ? 'arFont' : 'enFont'}`
">
                                        <v-text-field 
                                        :label="i18n['requested_withdrawal_amount_in_usd']" 
                                        :class="
  `${arabic ? 'arFont' : 'enFont'}`
" outlined dense @keypress="isNumber($event)" hide-details v-model="newRequest.value"></v-text-field>
                                      </v-col>
                                      <v-col cols="12" FIELD>
                                        <v-textarea :label="i18n['notes']" v-model="newRequest.note" :class="
  `${arabic ? 'arFont' : 'enFont'}`
" outlined hide-details dense></v-textarea>
                                      </v-col>
                                      <v-col cols="12" FIELD v-if="submitError">
                                        {{ submitError }}
                                      </v-col>
                                    </v-row>
                                  </v-card-text>
                                  <v-card-actions :class="`${arabic ? 'arFont' : 'enFont'}`">
                                    <v-spacer></v-spacer>
                                    {{ i18n['withdrawal_request_is_proccessed_in_48_hours'] }}
                                    <v-btn color="primary" text @click.native="dialog = false"
                                      :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n['cancel'] }}</v-btn>
                                    <v-btn color="primary" :disabled="!canSubmitForApproval"
                                      @click.native="sendRequest()" :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n['add'] }}
                                    </v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </v-layout>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class="py-0">
                        <v-row class="align-center">
                          <v-col cols="12">
                            <v-row class="align-center">
                              <v-col cols="12">
                                <v-card color="grey lighten-3" flat>
                                  <v-row class="align-center px-3">
                                    <v-col cols="12">
                                      <v-row class="align-center">
                                        <v-col cols="12" md="4" :class="
  `${arabic ? 'arFont' : 'enFont'}`
">
                                          {{ i18n['payment_method'] }}
                                        </v-col>
                                        <v-col cols="12" md="4" :class="
  `${arabic ? 'arFont' : 'enFont'}`
">
                                          {{ i18n['transaction_status'] }}
                                        </v-col>
                                        <v-col cols="12" md="4" :class="
  `${arabic ? 'arFont' : 'enFont'}`
">
                                          {{i18n['transaction_date_time']}}
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                    <v-col cols="12" v-for="(req, t) in requests.data" :key="'traxn-' + t"
                                      class="pa-0 mb-1 px-1">
                                      <v-card>
                                        <v-card-text>
                                          <v-row class="align-center py-0">
                                            <v-col cols="12" md="4" class="py-0" :class="
  `${arabic ? 'arFont' : 'enFont'
  }`
">
                                              <span v-if="req.method">{{
    req.method.name
}}</span>
                                              <v-chip x-small color="secondary" label class="mx-1" v-if="
  req.method &&
  paymentMethods.filter(
    (x) =>
      x.slug ==
      req.method.type
  ).length
" style="font-size:9px;">
                                                {{
    paymentMethods.filter(
      (x) =>
        x.slug == req.method.type
    )[0][language]
}}
                                              </v-chip>
                                            </v-col>
                                            <v-col cols="12" md="4" class="py-0" :class="
  `${arabic ? 'arFont' : 'enFont'
  }`
">
                                              <v-avatar size="10" :color="
  `${!req.reviewd &&
    !req.accepted
    ? 'secondary'
    : req.reviewd &&
      !req.accepted
      ? 'error'
      : req.reviewd &&
        req.accepted
        ? 'success'
        : 'secondary'
  }`
">
                                              </v-avatar>
                                              <span class="mx-1" v-if="
  !req.reviewd && !req.accepted
">{{ i18n['under_review'] }}</span>
                                              <span class="mx-1" v-if="
  req.reviewd && !req.accepted
">{{ i18n['rejected'] }}</span>
                                              <span class="mx-1" v-if="
  req.reviewd && req.accepted
">{{ i18n['was_approved'] }}</span>
                                            </v-col>
                                            <v-col cols="12" md="4" class="py-0" :class="
  `${arabic ? 'arFont' : 'enFont'
  }`
">
                                              <v-icon size="10">date_range</v-icon>
                                              {{ req.created_at.split("T")[0] }}
                                              |
                                              <v-icon size="10">schedule</v-icon>
                                              {{
    req.created_at
      .split("T")[1]
      .split(".")[0]
}}
                                            </v-col>
                                            <v-col cols="12" md="12" class="py-1" :class="
  `${arabic ? 'arFont' : 'enFont'
  }`
" v-if="req.admin_note">
                                              <v-divider></v-divider>
                                              <div>{{ i18n['note'] }}</div>
                                              <div>{{ req.admin_note }}</div>
                                            </v-col>
                                          </v-row>
                                        </v-card-text>
                                      </v-card>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6" class="pt-0" TRANSACTIONS>
            <v-row>
              <v-col cols="12" PANNELS>
                <v-card TRANSACTIONS :loading="loading">
                  <v-card-text class="py-0">
                    <v-row>
                      <v-col cols="12" class="pb-0">
                        <v-row class="align-center">
                          <v-col cols="2" md="2" class="text-center" TITLEICON>
                            <v-icon size="40" color="secondary">paid</v-icon>
                          </v-col>
                          <v-col cols="10" md="10" TITLE>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">
                              {{ i18n['transactions_and_paid_profits'] }}
                            </div>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} grey--text`">
                              {{ i18n['what_was_already_paid_from_your_profits'] }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class="py-0">
                        <v-row class="align-center">
                          <v-col cols="12" TOTALCARD class="pt-0">
                            <v-card color="success" class="text-center py-12" flat>
                              <div :class="`${arabic ? 'arFont' : 'enFont'} white--text`">
                                {{i18n['usd']}}
                              </div>
                              <div style="font-size:40px;" class="mt-5 white--text">
                                {{ trxns.sum }}
                              </div>
                            </v-card>
                          </v-col>
                          <v-col cols="12">
                            <v-row class="align-center">
                              <v-col cols="12">
                                <v-card color="grey lighten-3" flat>
                                  <v-row class="align-center px-3">
                                    <v-col cols="12">
                                      <v-row class="align-center">
                                        <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'}`">
                                          {{ i18n['amount'] }}
                                        </v-col>
                                        <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'}`">
                                          {{ i18n['status'] }}
                                        </v-col>
                                        <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'}`">
                                          {{ i18n['date'] }}
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                    <v-col cols="12" :class="`${arabic ? 'arFont' : 'enFont'}`">
                                      <Paging :resourceSettings="resourceSettings" :resource="trxns"
                                        @loadResource="loadResource" @pageByNumber="pageByNumber" />
                                    </v-col>
                                    <v-col cols="12" v-for="(trx, t) in trxns.data" :key="'traxn-' + t"
                                      class="py-0 mb-1 px-1">
                                      <v-card>
                                        <v-card-text>
                                          <v-row class="align-center py-0">
                                            <v-col cols="12" md="4" class="py-0"
                                              :class="`${arabic ? 'arFont' : 'enFont'}`">
                                              {{ trx.value }}
                                            </v-col>
                                            <v-col cols="12" md="4" class="py-0" :class="
                                                  `${arabic ? 'arFont' : 'enFont'
                                                  }`
                                                " v-if="
                                                  transaction_statuses.filter(
                                                    (x) => x.slug == trx.status
                                                  ).length
                                                ">
                                              <div>
                                                    {{
                                                    transaction_statuses.filter(
                                                      (x) => x.slug == trx.status
                                                    )[0][language]
                                                  }}
                                              </div>
                                              <div>
                                                <span v-if="trx.method">{{
                                                    trx.method.name
                                                }}</span>
                                                <v-chip x-small color="secondary" label class="mx-1" v-if="
                                                  trx.method &&
                                                  paymentMethods.filter(
                                                    (x) =>
                                                      x.slug ==
                                                      trx.method.type
                                                  ).length
                                                " style="font-size:9px;">{{
                                                    paymentMethods.filter(
                                                      (x) =>
                                                        x.slug ==
                                                        trx.method.type
                                                    )[0][language]
                                                }}</v-chip>
                                              </div>
                                            </v-col>
                                            <v-col cols="12" md="4" class="py-0" :class="
                                                `${arabic ? 'arFont' : 'enFont'
                                                }`
                                              ">
                                              <v-icon size="10">date_range</v-icon>
                                              {{ trx.created_at.split("T")[0] }}
                                              |
                                              <v-icon size="10">schedule</v-icon>
                                              {{
                                                  trx.created_at
                                                    .split("T")[1]
                                                    .split(".")[0]
                                              }}
                                            </v-col>
                                            <v-col cols="12" md="12" class="py-1" :class="
                                                `${arabic ? 'arFont' : 'enFont'
                                                }`
                                              " v-if="trx.note">
                                              <v-divider></v-divider>
                                              <div>{{i18n['note']}}</div>
                                              <div>{{ trx.note }}</div>
                                              <div>{{ trx.canceled_note }}</div>
                                            </v-col>
                                          </v-row>
                                        </v-card-text>
                                      </v-card>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import SubVendorInvoices from '@/components/SubVendorInvoices';
  import Paging from '@/components/Paging'

  export default {
    components: {
      SubVendorInvoices,
      Paging
    },
    data() {
      return {
        loading: false,
        dialog: false,
        vresource: [],
        resource: [],
        search: null,
        rules: {
          required: (value) => !!value || this.i18n["required"],
          email: (value) =>
            /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) ||
            this.i18n["valid_email"],
        },
        resourceKeys: [],
        resourceSettings: {
          resourceName: null,
          search: false,
          create: false,
          pagination: true,
        },
        newResource: {},
        editing: false,
        deleting: false,
        firstPanel: true,
        secondPanel: false,
        thirdPanel: false,
        selectedPanel: "firstPanel",
        subitems: [{
            text: "المعلومات الشخصية",
            icon: "person",
            value: "firstPanel",
          },
          {
            text: "تغيير كلمة المرور",
            icon: "password",
            value: "secondPanel",
          },
          {
            text: "الاحالات",
            icon: "loyalty",
            value: "thirdPanel",
          },
        ],
        counters: {},
        trxns: {},
        requests: {},
        pending_requests: false,
        accountPaymentMethods: [],
        newRequest: {},
        submitError: false,
        id_submissions: [],
        payment_methods: [],
        page: 1,
      };
    },
    methods: {
      goTo(path) {
        this.$router.push(path).catch(x => {})
      },
      isNumber(evt) {
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (
          charCode != 46 &&
          charCode != 45 &&
          charCode != 46 &&
          !(charCode >= 48 && charCode <= 57)
        ) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
      async getCounters() {
        return new Promise(async (res, rej) => {
          this.loading = true;
          this.counters = await this.$store.dispatch("getResource", {
            resource: `/leads-counters`,
          });
          console.log("this.counters", this.counters)
          this.trxns = await this.$store.dispatch("getResource", {
            resource: `/transactions?page=${this.page}`,
          });
          this.requests = await this.$store.dispatch("getResource", {
            resource: `/requests`,
          });
          this.accountPaymentMethods = await this.$store.dispatch("getResource", {
            resource: `/payment-methods`,
          });

          console.log(this.trxns);
          await this.getRequests();
          this.loading = false;
          res(true);
        });
      },
      async pageByNumber(n) {
        return new Promise(async () => {
          this.loading = true;
          this.page = n;
          this.trxns = await this.$store.dispatch('getResource', {
            resource: '/transactions',
            page: `?page=${this.page}`
          });
          this.loading = false;
        });
      },
      async loadResource() {
        return new Promise(async (res, rej) => {
          this.loading = true;
          this.trxns = await this.$store.dispatch('getResource', {
            resource: `/transactions?page=${this.page}`
          });
          this.loading = false;
          res();
        });
      },
      showPannel(v) {
        this[v] = true;
        let all = this.subitems.map((x) => x.value);
        all.filter((x) => x != v).forEach((x) => (this[x] = false));
      },
      setResourceName() {
        this.resourceSettings.resourceName = this.i18n[
          this.$route.path.replace("/", "")
        ];
      },
      async getRequests() {
        return new Promise(async (res, rej) => {
          let a = await this.$store.dispatch("getResource", {
            resource: `/requests`,
          });
          this.requests = a
          this.pending_requests = a.data.filter((x) => !x.reviewd).length ?
            true :
            false;
          // console.log(a)
          res(true);
        });
      },
      async sendRequest() {
        return new Promise(async (res, rej) => {
          this.loading = true;
          // console.log(this.user)
          await this.$store.dispatch("postResource", {
            resource: "/requests",
            value: this.newRequest,
          });
          await this.getRequests();
          this.dialog = false;
          this.loading = false;
          res(true);
        });
      },
      async getPaymentMethods() {
        return new Promise(async (res, rej) => {
          let sm = await this.$store.dispatch("getResource", {
            resource: `/payment-methods`,
          });
          console.log('payment_methods', sm)
          this.payment_methods = sm;
          res(true);
        });
      },
      async getSubmissions() {
        return new Promise(async (res, rej) => {
          let sm = await this.$store.dispatch("getResource", {
            resource: `/id-verification`,
          });
          this.id_submissions = sm.data;
          res(true);
        });
      },
    },
    computed: {
      disable_universal() {
        let pending = this.requests && this.requests.data && this.requests.data.length ? this.requests.data
          .filter((x) => !x.reviewd)
          .reduce(function (acc, obj) {
            return acc + parseFloat(obj.value);
          }, 0) : 0;

        if (!this.id_submissions.length) {
          return {
            disable: true,
            id_verification: true,
            error_message: this.i18n["please_verify_your_account_to_request_withdrawal"],
          };
        } else if (
          this.id_submissions.length &&
          !this.id_submissions.filter((x) => x.reviewed).length
        ) {
          return {
            disable: true,
            error_message: this.i18n['you_have_a_pending_verification_request'],
          };
        } else if (
          this.id_submissions.length &&
          !this.id_submissions.filter((x) => x.approved).length
        ) {
          return {
            disable: true,
            id_verification: true,
            error_message: this.i18n['you_have_no_approved_verification_request'],
          };
        } else if (!this.payment_methods || !this.payment_methods.length) {
          return {
            disable: true,
            payment_methods: true,
            error_message: this.i18n['you_have_no_approved_payment_method'],
          };
        } else if (
          this.payment_methods.length &&
          !this.payment_methods.filter((x) => x.reviewed).length
        ) {
          return {
            disable: true,
            error_message: this.i18n['all_payment_methods_are_under_review'],
          };
        } else if (
          this.payment_methods.length &&
          this.payment_methods.filter((x) => !x.approved).length
        ) {
          return {
            disable: true,
            payment_methods: true,
            error_message: this.i18n['you_dont_have_approved_payment_method'],
          };
        } else if (this.counters.total_ready < 25) {
          return {
            disable: true,
            error_message: this.i18n['you_dont_have_enough_profits_to_withdraw'],
          };
        } else if (pending >= this.counters.total_ready) {
          return {
            disable: true,
            error_message: this.i18n['you_cant_submit_one_more_withdrawal_request'],
          };
        } else {
          return false
        };
      },
      transaction_statuses() {
        return this.$store.state.transaction_statuses;
      },
      canSubmitForApproval() {
        if (this.newRequest && this.newRequest.payment_method_id) {
          let check_bank = this.accountPaymentMethods.filter(
            (x) => x.id == this.newRequest.payment_method_id
          )[0];
          if (check_bank.type == "bank") {
            if (parseFloat(this.counters.total_ready) > 500) {
              this.submitError = false;
              return true;
            } else {
              this.submitError = this.i18n['no_bank_withdrawal_under_500_usd'];
              return false;
            }
          } else if (parseFloat(this.counters.total_ready) >= 25) {
            this.submitError = false;
            return true;
          } else {
            this.submitError = this.i18n['no_withdrawal_allowed_before_25_ready_profits'];
            return false;
          }
        } else {
          this.submitError = this.i18n['please_refer_to_support_to_activate_withdrawals'];
          return false;
        }
      },
      disable_withdraw() {
        if (!this.requests || !this.requests.data) {
          return true;
        }
        let pending = this.requests.data
          .filter((x) => !x.reviewd)
          .reduce(function (acc, obj) {
            return acc + parseFloat(obj.value);
          }, 0);
        if (pending >= this.counters.total_ready) {
          return true;
        }
        if (this.counters.total_ready < 1) {
          return true;
        }
        return false;
      },
      api() {
        return this.$store.state.settings.apiBase;
      },
      users() {
        let sa =
          this.$store.state.user && this.$store.state.user.role == "superadmin";
        // console.log(sa)
        return this.$store.state.users.filter((x) => {
          if (!sa) {
            return x.superior == this.$store.state.user.level;
          } else return x;
        });
      },
      site() {
        return this.$store.state.site;
      },
      items() {
        return this.$store.state.menu;
      },
      superAdmin() {
        return this.$store.state.superAdmin;
      },
      isLogin() {
        return this.$store.state.centralLogin;
      },
      language() {
        return this.$store.state.language;
      },
      globalLoading() {
        return this.$store.state.globalLoading;
      },
      user() {
        return this.$store.state.user;
      },
      i18n() {
        return this.$store.state.i18n[this.$store.state.language];
      },
      arabic() {
        if (this.$store.state.language == "ar") return true;
      },
      routeTitle() {
        let main = this.$store.state.menu.filter(
          (x) => x.path == this.$route.path
        );
        let sub = []
          .concat(...this.$store.state.menu.map((x) => x.subs))
          .filter((x) => x)
          .filter((x) => x.path == this.$route.path);
        if (main.length) {
          return this.$store.state.i18n[this.$store.state.language][main[0].text];
        } else if (sub.length) {
          return this.$store.state.i18n[this.$store.state.language][sub[0].text];
        } else {
          return "";
        }
      },
      roles() {
        return this.$store.state.userRoles;
      },
      notifications() {
        return this.$store.state.notifications.sort(
          (a, b) => b.timestamp - a.timestamp
        );
      },
      paymentMethods() {
        return this.$store.state.paymentMethods;
      },
    },
    async created() {
      await this.getPaymentMethods();
      await this.getSubmissions();
      this.setResourceName();
      await this.getCounters();
    },
  };
</script>

<style>
  .statCard {
    border-top: solid 5px #9f0019 !important;
    border-bottom: solid 3px #9f0019 !important;
  }

  .statValue {
    font-size: 15px;
    font-weight: 500;
  }
</style>